import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  section: {
    marginBottom: theme.spacing(3),
  },
  stepRow: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: theme.spacing(2, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    gap: theme.spacing(2),
  },
  stepContent: {
    flexGrow: 1,
    minWidth: 0,
  },
  stepCheckboxes: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  infoBox: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    marginBottom: theme.spacing(3),
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  },
}));

export default useStyles;
